<app-crud 
  title="Category"
  [form]="form"
  [list]="list"
  [listTemplate]="listTemplate"
  [formTemplate]="formTemplate"
  (save)="save()"
  (remove)="remove($event)"
  >  
</app-crud>

<ng-template #formTemplate>
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Category</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>    
  </form>
</ng-template>

<ng-template #listTemplate let-data>
  {{data.name}}
</ng-template>